"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./coreGeom.js");
require("../styles/global");
require("../assets/images/png/logo/favicon.png");



//////////////////
// WEBPACK FOOTER
// ./src/libs/index.ts
// module id = 233
// module chunks = 1